import { gql } from 'apollo-angular';
import { DISCOUNT_GROUP_BASE_RELATION_FRAGMENT } from "./discount-group.definition";
import { DELETION_RESPONSE_FRAGMENT } from './system-definition';

export const DISCOUNT_GROUP_DOCUMENT_LINE_ITEM_RELATION_FRAGMENT = gql`
fragment DiscountGroupDocumentLineItemRelation on DiscountGroupDocumentLineItemRelation {
    ...DiscountGroupRelationBase
    # documentLineItemId
    # documentLineItem {
    #     ...DocumentLineItem
    # }
}
${DISCOUNT_GROUP_BASE_RELATION_FRAGMENT}
`;

export const GET_DISCOUNT_GROUP_DOCUMENT_LINE_ITEM_RELATIONS = gql`
query GetDiscountGroupDocumentLineItemRelations($input:DiscountGroupDocumentLineItemRelationSearchInput) {
    getDiscountGroupDocumentLineItemRelations(input: $input) {
        totalItems
        items {
            ...DiscountGroupDocumentLineItemRelation
        }
    }
}
${DISCOUNT_GROUP_DOCUMENT_LINE_ITEM_RELATION_FRAGMENT}
`;

export const GET_DISCOUNT_GROUP_DOCUMENT_LINE_ITEM_RELATION = gql`
query GetDiscountGroupDocumentLineItemRelation($id:String!) {
    getDiscountGroupDocumentLineItemRelation(id: $id) {
        ...DiscountGroupDocumentLineItemRelation
    }
}
${DISCOUNT_GROUP_DOCUMENT_LINE_ITEM_RELATION_FRAGMENT}
`;


export const SAVE_DISCOUNT_GROUP_DOCUMENT_LINE_ITEM_RELATION = gql`
mutation SaveDiscountGroupDocumentLineItemRelation($input: DiscountGroupDocumentLineItemRelationInput!) {
    saveDiscountGroupDocumentLineItemRelation(input: $input) {
        ... DiscountGroupDocumentLineItemRelation
    }
}
${DISCOUNT_GROUP_DOCUMENT_LINE_ITEM_RELATION_FRAGMENT}
`;

export const DELETE_DISCOUNT_GROUP_DOCUMENT_LINE_ITEM_RELATION = gql`
mutation DeleteDiscountGroupDocumentLineItemRelation($id: String!) {
    deleteDiscountGroupDocumentLineItemRelation(id: $id) {
        ... DeletionResponse
    }
}
${DELETION_RESPONSE_FRAGMENT}
`;